import React from 'react';
import './PrincipleCard.css';

const PrincipleCard = ({ text, icon }) => {
    return (
        <div className="principle-card">
            <div className="principle-card__icon">
                <i className={`fas ${icon}`} aria-hidden="true"></i>
            </div>
            <p className="principle-card__text">{text}</p>
        </div>
    );
};

export default PrincipleCard;
